import { render } from "./Manuals.vue?vue&type=template&id=df555f3e"
import script from "./Manuals.vue?vue&type=script&lang=js"
export * from "./Manuals.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__